import { DragAndDrop } from 'shared/components/dnd';
import LabelHelper from 'shared/components/LabelHelper';
import {observer} from 'mobx-react';
import {AssignmentRule} from 'main/stores/documents';
import {t} from 'shared/core';
import _ from 'lodash';

const DocumentAssignmentRules = observer(({assignmentRules}) => {
  const employeeRule = _.find(assignmentRules, {assigneeType: 'employee'})
    || new AssignmentRule({assigneeType: 'employee'});
  const reorderableRules = _.reject(assignmentRules, {assigneeType: 'employee'});

  if (_.isEmpty(reorderableRules)) return null;

  return (
    <div style={{marginTop: '1.25rem'}}>
      <LabelHelper label={t('company_settings.documents.Completion Order')} />
      <DragAndDrop
        readOnlyDisplay='nameWithOrder'
        readOnly
        models={[employeeRule]}
      />
      <DragAndDrop
        models={reorderableRules}
        display='nameWithOrder'
      />
    </div>
  );

});

export default DocumentAssignmentRules;
